// extracted by mini-css-extract-plugin
module.exports = {"cls1":"AppContainer_cls1__AD_q-","cls2":"AppContainer_cls2__Waty7 AppContainer_cls1__AD_q-"};